/* ==========================================================================
   LOOTY MINIMAL THEME — JS
   Drawers, carrinho via AJAX, barra de progresso (tiers), produto, vídeos,
   rastreio de pedido.
   ========================================================================== */
(function () {
  'use strict';

  var routes = (window.lootyTheme && window.lootyTheme.routes) || {};
  var tierLabels = (window.lootyTheme && window.lootyTheme.tiers && window.lootyTheme.tiers.labels) || [];

  /* ---------------- Toast ---------------- */
  function showToast(message) {
    var toast = document.getElementById('looty-toast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toast._timeout);
    toast._timeout = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2200);
  }

  /* ---------------- Drawers ---------------- */
  function openDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  function closeAllDrawers() {
    document.querySelectorAll('.looty-drawer.is-open').forEach(closeDrawer);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var menuToggle = document.getElementById('LootyMenuToggle');
    if (menuToggle) {
      menuToggle.addEventListener('click', function () {
        openDrawer(document.getElementById('LootyMenuDrawer'));
      });
    }

    // Busca o drawer no DOM a cada clique (nunca guarda referência fixa) — o carrinho
    // é substituído por um elemento novo via AJAX a cada mudança, então uma referência
    // guardada de antemão fica "presa" num nó que saiu da página.
    document.querySelectorAll('[data-cart-open], #LootyCartToggle, #LootyCartToggleFromHome').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openDrawer(document.getElementById('LootyCartDrawer'));
      });
    });

    // Delegado no document: funciona pros botões/overlay de fechar mesmo depois
    // do carrinho ser substituído via AJAX, sem precisar religar nada manualmente.
    document.addEventListener('click', function (e) {
      var closeTarget = e.target.closest('.looty-drawer [data-drawer-close]');
      if (closeTarget) closeDrawer(closeTarget.closest('.looty-drawer'));
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllDrawers();
    });

    initTiers();
    initCartTimer();
    initAddToCart();
    initQuantityControls();
    initProductPage();
    initVideoCommunity();
    initTrackingForm();
    initCollectionCarousel();
    initMenuCardCarousel();
    initReviewsFilter();
    initCartScrollIndicator();
  });

  /* ---------------- Indicador de "role para baixo" no carrinho ----------------
     Mesma lógica do menu lateral, mas como função em vez de <script> solto no HTML:
     o carrinho é substituído inteiro via AJAX a cada mudança, e um <script> dentro
     de HTML inserido por inovarHTML/replaceWith nunca executa — então isso precisa
     estar aqui e ser chamado de novo depois de cada refreshCartDrawer(). */
  function initCartScrollIndicator() {
    var content = document.getElementById('LootyCartContent');
    var indicator = document.getElementById('LootyCartScrollIndicator');
    if (!content || !indicator) return;

    function checkScroll() {
      var canScroll = content.scrollHeight > (content.clientHeight + 15);
      var isBottom = Math.ceil(content.scrollTop + content.clientHeight) >= (content.scrollHeight - 15);
      indicator.classList.toggle('is-visible', canScroll && !isBottom);
    }

    content.removeEventListener('scroll', content._lootyScrollHandler || checkScroll);
    content._lootyScrollHandler = checkScroll;
    content.addEventListener('scroll', checkScroll);

    checkScroll();
    setTimeout(checkScroll, 300);
    setTimeout(checkScroll, 800);
  }

  /* ---------------- Página geral de Avaliações: filtro por produto ---------------- */
  function initReviewsFilter() {
    var filtersWrap = document.querySelector('[data-reviews-filters]');
    var list = document.querySelector('[data-reviews-list]');
    if (!filtersWrap || !list) return;

    var cards = list.querySelectorAll('[data-review-product]');
    var buttons = filtersWrap.querySelectorAll('[data-reviews-filter]');

    function applyFilter(handle) {
      buttons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-reviews-filter') === handle);
      });
      cards.forEach(function (card) {
        var match = handle === 'all' || card.getAttribute('data-review-product') === handle;
        card.hidden = !match;
      });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyFilter(btn.getAttribute('data-reviews-filter'));
      });
    });

    // Pré-seleciona o filtro se a URL vier com ?produto=handle (link vindo da página de produto)
    var params = new URLSearchParams(window.location.search);
    var produtoParam = params.get('produto');
    if (produtoParam && filtersWrap.querySelector('[data-reviews-filter="' + produtoParam + '"]')) {
      applyFilter(produtoParam);
    }
  }

  /* ---------------- Carrossel do card em destaque no menu lateral ---------------- */
  function initMenuCardCarousel() {
    document.querySelectorAll('[data-menu-card-carousel]').forEach(function (carousel) {
      if (carousel._bound) return;
      carousel._bound = true;

      var slides = carousel.querySelectorAll('[data-menu-card-slide]');
      var dots = carousel.querySelectorAll('[data-menu-card-dot]');
      if (slides.length < 2) return; // só uma imagem: fica estática, sem carrossel

      var index = 0;
      var timer;

      function show(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (slide, idx) { slide.classList.toggle('is-active', idx === index); });
        dots.forEach(function (dot, idx) { dot.classList.toggle('is-active', idx === index); });
      }

      function startTimer() {
        clearInterval(timer);
        timer = setInterval(function () { show(index + 1); }, 4500);
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          show(i);
          startTimer();
        });
      });

      startTimer();
    });
  }

  /* ---------------- Carrinho: fetch estado atual (usado pelo widget "Seu carrinho possui") ---------------- */
  function fetchCart() {
    return fetch(routes.cartJsUrl || '/cart.js').then(function (r) { return r.json(); });
  }

  function updateCartCountAndStatus(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });

    var statusSection = document.querySelector('[data-cart-status]');
    if (statusSection) {
      if (cart.item_count > 0) {
        statusSection.hidden = false;
        var preview = statusSection.querySelector('[data-cart-status-preview]');
        if (preview && cart.items.length) {
          var first = cart.items[0];
          var extra = cart.item_count - first.quantity;
          preview.innerHTML =
            '<img src="' + first.image + '&width=160" alt="" width="64" height="64" loading="lazy">' +
            '<span class="looty-cart-status__text">' + first.quantity + 'x ' + first.product_title +
            ' - ' + formatMoney(first.final_line_price) +
            (extra > 0 ? ' + ' + extra + ' outro(s)' : '') + '</span>';
        }
      } else {
        statusSection.hidden = true;
      }
    }
  }

  /* ---------------- Carrinho: re-renderiza o drawer inteiro via Section Rendering API ----------------
     Isso é necessário porque o order bump (tags de produto, preços, coleções de fallback) é calculado
     em Liquid — um simples cart.js (JSON) não carrega essas informações, então buscamos o HTML
     já processado da section 'cart-drawer' a cada mudança no carrinho. */
  function refreshCartDrawer() {
    var url = (routes.rootUrl || '/') + '?section_id=cart-drawer';
    return fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var newDrawer = temp.querySelector('#LootyCartDrawer');
        var oldDrawer = document.getElementById('LootyCartDrawer');
        if (!newDrawer || !oldDrawer) return;

        var wasOpen = oldDrawer.classList.contains('is-open');
        if (wasOpen) {
          newDrawer.classList.add('is-open');
          newDrawer.setAttribute('aria-hidden', 'false');
        }
        oldDrawer.replaceWith(newDrawer);

        var itemCount = parseInt(newDrawer.getAttribute('data-item-count'), 10) || 0;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = itemCount; });
        updateTiers(itemCount);

        if (itemCount === 0) {
          sessionStorage.removeItem('looty_cart_timer_expiry');
        }

        // Fechar/reabrir já funciona sozinho (delegado no document) — só falta
        // religar o que depende de estar diretamente no elemento novo.
        initQuantityControls();
        initAddToCart();
        initCartTimer();
        initCartScrollIndicator();
      });
  }

  function formatMoney(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  /* ---------------- Timer de reserva do carrinho ---------------- */
  function initCartTimer() {
    var el = document.querySelector('[data-cart-timer]');
    clearInterval(window._lootyCartTimerInterval);
    if (!el) return;

    var valueEl = el.querySelector('[data-cart-timer-value]');
    var minutes = parseInt(el.getAttribute('data-duration'), 10) || 15;
    var key = 'looty_cart_timer_expiry';
    var expiry = parseInt(sessionStorage.getItem(key), 10);
    var now = Date.now();

    if (!expiry || expiry < now) {
      expiry = now + minutes * 60 * 1000;
      sessionStorage.setItem(key, String(expiry));
    }

    function tick() {
      var remaining = Math.max(0, expiry - Date.now());
      var m = Math.floor(remaining / 60000);
      var s = Math.floor((remaining % 60000) / 1000);
      if (valueEl) valueEl.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      if (remaining <= 0) clearInterval(window._lootyCartTimerInterval);
    }

    tick();
    window._lootyCartTimerInterval = setInterval(tick, 1000);
  }

  /* ---------------- Adicionar ao carrinho (vitrines, página de produto e order bump) ---------------- */
  function initAddToCart() {
    document.querySelectorAll('[data-add-to-cart], [data-add-bump]').forEach(function (btn) {
      if (btn._bound) return;
      btn._bound = true;
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;
        var quantity = 1;
        if (btn.id === 'LootyProductAddBtn') {
          var productSection = btn.closest('[data-product-section]');
          var qtyInput = productSection ? productSection.querySelector('[data-product-qty]') : null;
          if (qtyInput) quantity = Math.max(1, parseInt(qtyInput.value, 10) || 1);
        }
        btn.classList.add('is-loading');
        addToCart(variantId, quantity).then(function () {
          btn.classList.remove('is-loading');
          showToast('Adicionado ao carrinho!');
          var cartDrawer = document.getElementById('LootyCartDrawer');
          openDrawer(cartDrawer);
        });
      });
    });
  }

  function addToCart(variantId, quantity) {
    return fetch(routes.cartAddUrl || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        fetchCart().then(updateCartCountAndStatus);
        return refreshCartDrawer();
      });
  }

  /* ---------------- Quantidade no drawer do carrinho ---------------- */
  function initQuantityControls() {
    document.querySelectorAll('[data-cart-item]').forEach(function (item) {
      var line = parseInt(item.getAttribute('data-line'), 10);
      var valueEl = item.querySelector('[data-qty-value]');
      var decrease = item.querySelector('[data-qty-decrease]');
      var increase = item.querySelector('[data-qty-increase]');
      if (decrease && !decrease._bound) {
        decrease._bound = true;
        decrease.addEventListener('click', function () {
          var qty = Math.max(0, parseInt(valueEl.textContent, 10) - 1);
          changeCartLine(line, qty);
        });
      }
      if (increase && !increase._bound) {
        increase._bound = true;
        increase.addEventListener('click', function () {
          var qty = parseInt(valueEl.textContent, 10) + 1;
          changeCartLine(line, qty);
        });
      }
    });
  }

  function changeCartLine(line, quantity) {
    fetch(routes.cartChangeUrl || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        fetchCart().then(updateCartCountAndStatus);
        return refreshCartDrawer();
      });
  }

  /* ---------------- Barra de progresso (Tiers) ---------------- */
  /* Usa querySelectorAll: pode existir mais de uma barra na página (ex: menu lateral + carrinho) */
  function updateTiers(itemCount) {
    var fills = document.querySelectorAll('[data-tiers-fill]');
    if (!fills.length) return;

    var tier = Math.min(itemCount, 3);
    var percent = (tier / 3) * 100;

    fills.forEach(function (fill) {
      fill.style.width = percent + '%';
      fill.classList.toggle('is-complete', tier >= 3);
    });

    [1, 2, 3].forEach(function (t) {
      document.querySelectorAll('[data-tier-dot="' + t + '"]').forEach(function (dot) {
        dot.classList.toggle('is-active', tier >= t);
        // O anel pulsante marca só o tier mais recente alcançado (sensação de progresso "ao vivo")
        dot.classList.toggle('is-current', tier === t && tier > 0);
      });
    });

    if (tierLabels.length) {
      var idx = Math.max(0, Math.min(tier, tierLabels.length - 1));
      var newText = tierLabels[idx] || tierLabels[0];
      document.querySelectorAll('[data-tiers-caption]').forEach(function (caption) {
        if (caption.textContent.trim() !== newText) {
          caption.classList.add('is-updating');
          setTimeout(function () {
            caption.textContent = newText;
            caption.classList.remove('is-updating');
          }, 200);
        }
      });
    }
  }

  function initTiers() {
    var initialCart = window.lootyTheme && window.lootyTheme.cart;
    if (initialCart) updateTiers(initialCart.item_count);
  }

  /* ---------------- Página de produto ---------------- */
  function initProductPage() {
    var section = document.querySelector('[data-product-section]');
    if (!section) return;

    // Troca de imagem via thumbs
    var mainImage = document.getElementById('LootyProductMainImage');
    section.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImage) mainImage.src = thumb.getAttribute('data-image-src');
        section.querySelectorAll('[data-product-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    // Stepper de quantidade
    var qtyInput = section.querySelector('[data-product-qty]');
    var qtyDecrease = section.querySelector('[data-product-qty-decrease]');
    var qtyIncrease = section.querySelector('[data-product-qty-increase]');
    if (qtyInput && qtyDecrease && qtyIncrease) {
      qtyDecrease.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      });
      qtyIncrease.addEventListener('click', function () {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      });
    }

    // Troca de variante: recalcula preço, parcela e disponibilidade sem recarregar a página
    var variantsRaw = section.getAttribute('data-variants');
    if (!variantsRaw) return;
    var variants;
    try { variants = JSON.parse(variantsRaw); } catch (e) { return; }

    var optionInputs = section.querySelectorAll('[data-option-position]');
    if (!optionInputs.length) return;

    var priceEl = section.querySelector('[data-product-price]');
    var installmentEl = section.querySelector('[data-product-installment]');
    var addBtn = document.getElementById('LootyProductAddBtn');
    var addLabel = addBtn ? addBtn.querySelector('[data-add-to-cart-label]') : null;

    function getSelectedOptions() {
      var selected = [];
      var positions = {};
      optionInputs.forEach(function (input) {
        if (input.checked) positions[input.getAttribute('data-option-position')] = input.value;
      });
      var maxPos = Math.max.apply(null, Object.keys(positions).map(Number));
      for (var i = 1; i <= maxPos; i++) selected.push(positions[i]);
      return selected;
    }

    function findMatchingVariant() {
      var selected = getSelectedOptions();
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3].filter(function (o) { return o !== null; });
        return opts.length === selected.length && opts.every(function (o, i) { return o === selected[i]; });
      });
    }

    function applyVariant(variant) {
      if (!variant) return;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (installmentEl) installmentEl.textContent = formatMoney(Math.round(variant.price / 3));
      if (variant.featured_image && mainImage) mainImage.src = variant.featured_image.src.replace(/(\.[a-z]{3,4})(\?|$)/i, '_800x$1$2');
      if (addBtn) {
        addBtn.setAttribute('data-variant-id', variant.id);
        addBtn.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? 'Adicionar ao Carrinho' : 'Esgotado';
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        applyVariant(findMatchingVariant());
      });
    });
  }

  /* ---------------- Vídeo comunidade (upload real, expande com blur) ---------------- */
  function initVideoCommunity() {
    var backdrop = document.querySelector('[data-video-backdrop]');

    function closeVideoItem(item) {
      if (!item) return;
      item.classList.remove('is-expanded');
      var video = item.querySelector('video');
      if (video) video.pause();
      if (backdrop) backdrop.classList.remove('is-visible');
    }

    function openVideoItem(item) {
      // Fecha qualquer outro vídeo aberto antes de abrir este
      document.querySelectorAll('.looty-videos__item.is-expanded').forEach(function (openItem) {
        if (openItem !== item) closeVideoItem(openItem);
      });
      item.classList.add('is-expanded');
      if (backdrop) backdrop.classList.add('is-visible');
      var video = item.querySelector('video');
      if (video) {
        video.currentTime = 0;
        video.play().catch(function () {});
      }
    }

    document.querySelectorAll('[data-video-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-video-item]');
        if (item) openVideoItem(item);
      });
    });

    document.querySelectorAll('[data-video-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeVideoItem(btn.closest('.looty-videos__item'));
      });
    });

    if (backdrop) {
      backdrop.addEventListener('click', function () {
        var openItem = document.querySelector('.looty-videos__item.is-expanded');
        closeVideoItem(openItem);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var openItem = document.querySelector('.looty-videos__item.is-expanded');
        if (openItem) closeVideoItem(openItem);
      }
    });

    // Vídeo de review na página de produto (continua abrindo por link externo)
    document.querySelectorAll('[data-video-url]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-video-url');
        if (!url) return;
        window.open(url, '_blank', 'noopener');
      });
    });
  }

  /* ---------------- Carrossel: arrastar com mouse + setas (desktop) e swipe (mobile via scroll nativo) ---------------- */
  function initCollectionCarousel() {
    document.querySelectorAll('[data-carousel]').forEach(function (track) {
      var isDown = false, startX, scrollLeft, dragged = false;
      var DRAG_THRESHOLD = 10; // px de movimento real do mouse para contar como arraste

      track.addEventListener('mousedown', function (e) {
        isDown = true;
        dragged = false;
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
      });
      ['mouseleave', 'mouseup'].forEach(function (evt) {
        track.addEventListener(evt, function () { isDown = false; });
      });
      track.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        var x = e.pageX - track.offsetLeft;
        var rawDelta = x - startX;
        if (Math.abs(rawDelta) > DRAG_THRESHOLD) {
          dragged = true;
          e.preventDefault();
          track.scrollLeft = scrollLeft - rawDelta * 1.2;
        }
      });
      // Só cancela o clique se realmente houve arraste, e nunca em botões/links
      // (evita bloquear o play do vídeo, o "Adicionar" e os cards por tremulação do mouse)
      track.addEventListener('click', function (e) {
        if (dragged && !e.target.closest('button, a')) {
          e.preventDefault();
        }
        dragged = false;
      }, true);
    });

    // Setas de navegação (desktop): rolam pela largura aproximada de um card
    document.querySelectorAll('.looty-carousel').forEach(function (wrapper) {
      var track = wrapper.querySelector('[data-carousel]');
      var prevBtn = wrapper.querySelector('[data-carousel-prev]');
      var nextBtn = wrapper.querySelector('[data-carousel-next]');
      if (!track) return;

      function scrollByCard(direction) {
        var firstCard = track.firstElementChild;
        var cardWidth = firstCard ? firstCard.getBoundingClientRect().width + 14 : 180;
        track.scrollBy({ left: cardWidth * direction, behavior: 'smooth' });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });
    });
  }


  /* ---------------- Rastreio de pedido ---------------- */
  function initTrackingForm() {
    var form = document.querySelector('[data-tracking-form]');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var orderCode = form.querySelector('input[name="order_code"]').value.trim();
      var resultBox = document.querySelector('[data-tracking-result]');
      var statusEl = document.querySelector('[data-tracking-status]');
      var correiosLink = document.querySelector('[data-tracking-correios-link]');
      var errorEl = document.querySelector('[data-tracking-error]');
      var apiUrl = form.getAttribute('data-api-url') || (window.lootyTheme && window.lootyTheme.trackingApiUrl);

      resultBox.hidden = true;
      errorEl.hidden = true;

      if (!apiUrl) {
        // Sem endpoint configurado: apenas confirma o recebimento do código.
        statusEl.textContent = 'Recebemos seu pedido ' + orderCode + '. Configure a URL do sistema de rastreio em Configurações do Tema para exibir o status real.';
        correiosLink.hidden = true;
        resultBox.hidden = false;
        return;
      }

      fetch(apiUrl + '?order=' + encodeURIComponent(orderCode))
        .then(function (r) {
          if (!r.ok) throw new Error('not found');
          return r.json();
        })
        .then(function (data) {
          statusEl.textContent = data.status || 'Status indisponível.';
          if (data.tracking_url) {
            correiosLink.href = data.tracking_url;
            correiosLink.hidden = false;
          } else {
            correiosLink.hidden = true;
          }
          resultBox.hidden = false;
        })
        .catch(function () {
          errorEl.hidden = false;
        });
    });
  }
})();